import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const WHATSAPP_LINK = "https://wa.me/529841585732?text=Hola%2C%20quiero%20agendar%20una%20consulta%20gratuita%20con%20Marea%20Riviera";

export const TopBanner = () => {
  const { language } = useLanguage();

  return (
    <div
      data-testid="top-banner"
      className="fixed top-20 left-0 right-0 z-40 bg-[#2BBFBF] flex items-center justify-center px-4 gap-3"
      style={{ height: '40px' }}
    >
      <p className="font-inter text-[#0A2235] text-xs sm:text-sm font-medium truncate">
        {language === 'es'
          ? '\u{1F30A} Consulta gratuita con nuestros asesores — Sin compromiso · Respuesta en menos de 2 horas'
          : '\u{1F30A} Free consultation with our advisors — No commitment · Response in less than 2 hours'}
      </p>
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-shrink-0 bg-[#0A2235] text-[#FAFAF7] text-xs font-medium px-3 py-1 rounded-full hover:bg-[#0A2235]/80 transition-colors"
        data-testid="top-banner-cta"
      >
        {language === 'es' ? 'Agendar →' : 'Book →'}
      </a>
    </div>
  );
};
